import { Rocket } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { SetupGuidePage } from '@/pages/admin/SetupGuidePage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'setup',
  routes: {
    admin: [
      {
        path: 'setup',
        element: (
          <RequirePermission permission="school.manage">
            <SetupGuidePage />
          </RequirePermission>
        ),
      },
    ],
  },
  nav: {
    admin: [
      {
        group: 'Administration',
        order: 5,
        item: {
          label: 'Setup guide',
          to: '/admin/setup',
          icon: Rocket,
          permission: 'school.manage',
          keywords: 'onboarding getting started checklist first steps',
        },
      },
    ],
  },
}
